import script from "./WCConfiguredProductSectionRows.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCConfiguredProductSectionRows.vue?vue&type=script&setup=true&lang=ts"

import "./WCConfiguredProductSectionRows.vue?vue&type=style&index=0&id=355e973c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-355e973c"]])

export default __exports__